import { render, staticRenderFns } from "./TradingNotes.vue?vue&type=template&id=d707b84c&scoped=true&"
import script from "./TradingNotes.vue?vue&type=script&lang=js&"
export * from "./TradingNotes.vue?vue&type=script&lang=js&"
import style0 from "./TradingNotes.vue?vue&type=style&index=0&id=d707b84c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d707b84c",
  null
  
)

export default component.exports